import React from 'react';

function Button({ children, title, variant = 'default', size = 'default', ...props }) {
    const baseClasses = 'font-medium rounded focus:outline-none';
    const variantClasses = {
        default: 'bg-blue-500 text-white hover:bg-blue-600',
        outline: 'border border-gray-300 text-gray-700 hover:bg-gray-50',
        green: 'bg-green-600 text-white hover:bg-green-700 focus:ring-green-500',
        destructive: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500',
    };
    const sizeClasses = {
        default: 'px-2 py-1 ml-1 last:mr-0 text-sm',
        sm: 'px-2.5 py-2.5 ml-1 last:mr-0 text-xs',
        lg: 'px-6 py-3 ml-1 last:mr-0 text-base',
    };

    const className = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} last:mr-0`;

return (
    <button className={className} {...props} title={title}>
      {children}
    </button>
);
}

export default Button;